import VideoPlayer from './VideoPlayer'

export default VideoPlayer
// eslint-disable-next-line import/export
export * from './VideoPlayer'
